<div class="match-contacts-list">
	<app-loader *ngIf="isMatchContactsListLoading" [hasTransparency]="'true'" [isHorizontalLoader]="'true'">
	</app-loader>
	<div class="contact-container" *ngFor="let contact of matchingContacts">
		<div class="contact-name">
			<span>{{ contact.firstName }} {{ contact.lastName }}</span>
			<span class="actions">
				<span class="message">(already active)</span>
				<span class="action" *ngIf="filter.contactId" (click)="replaceContact(contact.refId)">Replace
					current</span>
				<span class="action" *ngIf="filter.contactId == null && !contact.onSite"
					(click)="applyToSite(contact.refId)">Apply to site</span>
				<span class="action" *ngIf="filter.contactId == null && contact.onSite"
					(click)="show(contact.refId)">Show</span>
			</span>
		</div>
		<div class="contact-details">
			<span class="contact-email" [class.match]="contact.isMatchByEmail">{{ contact.email }}</span>
			<span class="contact-phone" [class.match]="contact.isMatchByPhone">{{ contact.phone }}</span>
		</div>
	</div>
</div>